
import { HeadlineTitle, HeadlineImage, HeadlineAuthor, HeadlineLabels, HeadlineIcons, HeadlineRelatedTitle, HeadlineLead } from '../../../fragments';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/1-10/blockType2';
import getItemFromObject from 'lodash/get';

const defaultSettings = {
  icons: true,
  author: true,
  titleComment: true,
  channel: true,
  category: true,
  relatedTitles: true,
  lead: true,
  type: 'list',
  adsInject: null,
  indexOffset: 0,
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    HeadlineImage,
    HeadlineTitle,
    HeadlineAuthor,
    HeadlineLabels,
    HeadlineIcons,
    HeadlineRelatedTitle,
    HeadlineLead,
    AdFormBanner,
  },
  methods: {
    getItemFromObject,
  },
});
